<template>
    <section class="font-poppins">
        <div class="flex justify-between md:flex-col " style="height:85vh">
            <div class="w-2/3 lg:w-full mb-20">
                <div class="flex justify-around mt-8">
                    <router-link to="/"><img class="md:w-1/2 w-4/5 pl-3"  src="https://res.cloudinary.com/https-carrygo-com/image/upload/v1634105033/carrygoWebAssets/carrygo_logo_vrdtw8.svg" alt="logo"></router-link>
                    <p class="mr-10 text-blue-600 text-2xl md:text-sm">2/5</p>
                </div>

                <div class="flex justify-center md:flex-col md:w-4/5 lg:m-auto">
                    <div>
                        <div class="text-4xl mt-10 flex justify-content-center  md:text-lg">
                            <h2 class="text-blue-600 font-semibold" style="color:rgb(18,84,179)">Sign Up as a DSP</h2>
                        </div>
                        <div class="w-4/5 md:w-full">

                            
                            <!-- --EMAIL VERIFICATION -->
                            <div >
                                <form @submit.prevent="_verifyEmail">
                                    <div class="mt-8 font-semibold">
                                        <p>Enter your Email Address</p>
                                    </div>
                                    <p class="text-xs text-green-500" v-show="isCodeSent">Code sent successfully. Please check your email</p>
                                    <p class="text-xs text-red-500" v-show="codeFailed">Code was not sent</p>
                                    <p class="text-xs text-green-500" >{{otpStatus}}</p>
                                    <p v-show="isEmailTaken" class="text-red-500 text-sm">Email already exists.</p>
                                    <div class="mt-5">
                                        <label for="phone">Email Address</label> <br>
                                        <div class="mt-2 ">
                                            <div>
                                                <input v-model="email" style="border:1px solid rgb(18,84,179) "  class="w-full border p-1 rounded-lg" type="email" name="email" id="email">
                                                <p v-if="emailValidity === true " class="text-xs text-red-500">please enter your email address</p>
                                            </div>       
                                        </div>
                                        <div class="mt-3">
                                            <input class="w-full border bg-gray-100 p-2 rounded-lg text-sm" type="number" name="code" id="code" placeholder="Enter code" v-model="emailOtp">
                                            <p v-if="codeValidity === 'invalid' " class="text-xs text-red-500">please enter code</p>
                                            <span class="text-xs ml-1 mt-2 cursor-pointer" style="color:rgb(18,84,179)"><a @click="checkEmail">Send Code</a></span>
                                            <p class="text-sm text-red-500">{{emailError}}</p>
                                        </div>

                                        <div class="mt-10 flex">
                                            <button class="w-full text-white rounded p-1" style="background-color:rgb(18,84,179)">Proceed</button>
                                            <p v-if="isLoading" class="ml-2 mt-2 animate-spin rounded-full h-6 w-6 border border-t-2 border-b-2 border-blue-900 "></p>
                                        </div>

                                        <div class="mt-5 mb-5 text-sm text-center">
                                            <p>Already have an account? 
                                                <span @click="showModal" class="text-blue-500">Login</span>    
                                            </p>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>      
                    </div>      
                </div>
                
            </div>

            <div class="image w-1/3  md:hidden">

            </div>
        </div>

        <div class="lg:hidden">
            <the-footer/>
        </div>

        <ComingSoonModal 
            v-show="isModalVisible"
            @click="close"
            />
    </section>
</template>

<script>
import axios from 'axios';
import ComingSoonModal from '../../ComingSoonModal.vue';
import {baseUrl} from '../../../../Config';
const url = baseUrl;
export default {
    components:{ComingSoonModal},
    data() {
        return {
            code: "",
            number: "",
            otp: "",
            emailOtp:"",
            mobileNumber: "",
            numberValidity: "",
            codeValidity:"",
            isLoading: false,
            countryCode: [],
            displayError: "",
            isCodeSent: false,
            codeFailed: false,
            isModalVisible: false,
            email: "",
            emailValidity: false,
            emailError: "",
            isEmailTaken: false,
            isOtpSent: false,
            otpStatus: ""
        }
    },

    mounted() {
        this.networkError();
    },

    methods: {
        close() {
            this.isModalVisible = false;
        },
        showModal() {
            this.isModalVisible = true;
        },
         networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        },

        


        sendEmailCode() {
                this.$store.commit('userEmail', this.email);
                localStorage.setItem("dsoEmail", this.email);
                axios({
                    method: 'POST',
                    url: `${url}/v1/web/auth/otp/email/send`,
                    headers: {
                        'Content-type': 'application/json',
                        'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    },
                    data: {
                        email: String(this.email)
                    }
                })
                .then((response) => {
                    response.json;
                    this.isCodeSent = true;
                    setTimeout(() => {
                        this.isCodeSent = false;
                    }, 3000);
                    this.isOtpSent = true;
                })
                .catch((error) => {
                    error
                    this.codeFailed = true;
                     setTimeout(() => {
                        this.codeFailed = false;
                    }, 3000);
                }) 
        },

        _verifyEmail() {
            this.networkError();
            if(!this.email) {
                this.emailValidity = true;
                 setTimeout(() => {
                    this.emailValidity = false;
                }, 3000);
            } else if (!this.emailOtp) {
                this.codeValidity = 'invalid';
                 setTimeout(() => {
                    this.codeValidity = false;
                }, 3000);
            } else {
                this.isLoading =  true;
            axios({
                method: 'POST',
                url: `${url}/v1/web/auth/otp/email/verify`,
                headers: {
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data: {
                    email: this.email,
                    otp: String(this.emailOtp)
                }
            })
            .then((res) => {
                this.$router.push('/dso-step2-registration')
                this.isLoading = false           
                res.json
            })
            .catch((error) => {
                this.emailError = error.response.data.message;
                 setTimeout(() => {
                    this.emailError = "";
                }, 3000);
                this.isLoading = false;
            })
            }
            
        },

        checkEmail() {
            this.networkError();
            if(this.isOtpSent == true) {
                this.otpStatus = "OTP code already sent. Kindly Check your email"
                setTimeout(() => {
                    this.otpStatus = "";
                }, 3000);
            }else if(!this.email) {
                this.emailValidity = true 
                setTimeout(() => {
                        this.emailValidity = false;
                    }, 3000);
            } else {

                axios({
                    method: 'GET',
                    url: `${url}/v1/web/users/email/check/${this.email}`,
                    headers: {
                        'Content-type': 'application/json',
                        'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    }
                })
                .then((response) => {
                    response;
                    this.sendEmailCode();
                    
                })
                .catch((error) => {
                    if (error.response.data.status == false) {
                        this.isEmailTaken = true;
                         setTimeout(() => {
                            this.isEmailTaken = false;
                        }, 6000);
                    }
                })
            }
        },
    }
}
</script>



<style scoped>
.image {
    background-image: url("../Image/sea.png");
    background-repeat: no-repeat;
}
</style>
